var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportLayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 51.395,
    viewBox: "0 0 52 51.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -2.936)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.936)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.848,81.3l7.765,7.765,7.765-7.765-2.333-2.333-3.783,3.783V66.936h-3.3V82.75l-3.783-3.783Z",
    transform: "translate(-172.964 -60.337)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,132.258l-13.382-7.712-1.65,2.857,8.43,4.855-14.12,8.159L6.6,126.17l14.121-8.158,1.155.66,1.65-2.861-2.8-1.612L0,126.17l8.578,4.949L0,136.068l31.278,18.054L52,142.156l-8.578-4.949Zm-6.6,9.9-14.123,8.159L6.6,136.068l5.279-3.044,19.4,11.2,8.847-5.114Z",
    transform: "translate(0 -102.728)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.299,
    height: 3.299,
    transform: "translate(25.999)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportLayer);
export default __webpack_public_path__ + "static/media/import-layer.387a08be74904402f1a77aff751711de.svg";
export { ForwardRef as ReactComponent };